import React, { Component } from 'react';
import VideoPlayer from '../common/videoPlayer';

export default class FreeToGuest extends Component {
  /**************
   * Properties *
   **************/

  state = {
    videoNavigationBar: {
      mainMenu: false,
      back: false,
      backRoute: null,
      doGoBack: true
    },
    videos: {
      white_noise: require('./videos/248131HD_WhiteNoise.mp4'),
      relaxation: require('./videos/107410HD_Vermont_Balloons_Relaxation.mp4'),
      cvod_orientation: require('./videos/317441HD_Orientation_CVOD.mp4')
    }
  };

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    // Get the channel name from URL params. React Router places URL params in it's match object.
    const channelName = this.props.match.params.channelName;
    return (
      <VideoPlayer
        id={channelName}
        src={this.state.videos[channelName]}
        navigationBar={this.state.videoNavigationBar}
      />
    );
  }
}
